import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/hotels/fairmont-2.webp")